import type { AllRouteEndpoints } from "../routeTypes";
export const engagementInAppMessageColorProfilesDuplicateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/in_app_message_color_profiles",
];
